<template>
  <div>
    <div class="card-header">
      <form class="box-search" @submit.prevent="submitForm">
        <div class="form-group">
          <div class="date-range-container">
            <DateRangePicker
              placeholder="Thời gian nhập"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder">
                  Thời gian nhập TB
                </label>
              </template>
            </DateRangePicker>
          </div>
        </div>

        <div class="form-group">
          <div class="date-range-container">
            <DateRangePicker
              placeholder="Thời gian kích hoạt"
              class="w-100"
              :ranges="false"
              @update="transformActivationDate()"
              v-model="activationDateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder">
                  Thời gian kích hoạt TB
                </label>
              </template>
            </DateRangePicker>
          </div>
        </div>
         <div class="form-group">
            <Select2
              placeholder="Đối tác"
              v-model="search.partnerCode"
              :options="partnerCodeMap"
            >
            </Select2>
          </div>

        <div class="form-group">
          <input
            type="text"
            v-model="search.serial"
            class="form-control"
            placeholder="Nhập mã thiết bị"
          />
        </div>

        <div class="form-group">
          <input
            type="text"
            v-model="search.mcMobile"
            class="form-control"
            placeholder="Nhập SĐT"
          />
        </div>

        <!-- <div class="form-group">
          <input
            type="text"
            v-model="search.mcAccountNo"
            class="form-control"
            placeholder="Số TK ngân hàng"
          />
        </div> -->

        <div class="form-group">
          <Select2
            v-model="search.agentIds"
            :settings="searchAgent"
            placeholder="Tìm kiếm chi nhánh"
          ></Select2>
        </div>

        <div class="form-group">
          <Select2
            v-model="search.inviteCodes"
            :settings="setTingsInviteCode"
            placeholder="Tìm mã cán bộ"
          ></Select2>
        </div>

        <div class="form-group filter-button-group">
          <button
            @click="submitForm"
            class="pt-2 mr-2 btn btn-primary hc-37"
            data-toggle="tooltip"
            data-placement="top"
            title="Lọc"
          >
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
          </button>
          <button
            @click="resetFilters"
            type="button"
            class="pt-2 mr-2 btn btn-outline-light hc-37"
            data-toggle="tooltip"
            data-placement="top"
            title="Bỏ lọc"
          >
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
          </button>
        </div>
      </form>
    </div>

    <div class="card-body">
      <div class="tab-content" id="nav-tabContent">
        <div class="p-0">
          <b-table
            :busy.sync="loading"
            sticky-header
            hover
            responsive
            :items="tableData"
            :fields="tableFields"
            :fixed="true"
            :bordered="true"
            class="custom-table"
          >
            <template #table-busy>
              <div class="my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
          </b-table>

          <div class="pagination-container"></div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.total"
        :per-page="pagination.limit"
        @change="onChangePage"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Config from '@/thirdParty/config'
import { ReportService } from '@/services/report.service'
import { CommonService } from '@/services/common.service'

const STATUS_MAP = {
  AVAILABLE: 'Khả dụng',
  SOLD: 'Đã bán',
  USED: 'Đã qua sử dụng'
}

const tableFields = [
  { key: 'index', label: 'STT', class: 'text-center', thStyle: { width: '80px' }, tdStyle: { width: '80px' } },
  { key: 'serial', label: 'Mã thiết bị' },
  { key: 'mcMobile', label: 'SĐT Merchant' },
  { key: 'mcHolderName', label: 'Tên chủ TK' },
  { key: 'agentName', label: 'Chi nhánh' },
  { key: 'inviteCode', label: 'Mã cán bộ' },
  { key: 'mcAccountNo', label: 'STK KH' },
  { key: 'importedTimeStr', label: 'Thời điểm nhập' },
  { key: 'activatedTimeStr', label: 'Thời điểm kích hoạt thiết bị' },
  { key: 'status', label: 'Trạng thái thiết bị', formatter: (value) => STATUS_MAP[value] || '' },
  { key: 'recallTimeStr', label: 'Thời gian thu hồi' },
  { key: 'recallReason', label: 'Lí do thu hồi' }
]

export default {
  name: 'DeviceVAReport',
  data () {
    return {
      partnerCodeMap: [],
      loading: false,
      tableFields,
      optionEmployees: [
        { id: '0', text: 'Tất cả' },
        { id: 'NV001', text: 'NV001' },
        { id: 'NV002', text: 'NV002' },
        { id: 'NV003', text: 'NV003' }
      ],
      setTingsInviteCode: {
        multiple: true,
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListInviteCode({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.inviteCode,
                          text: item.inviteCode || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      },
      searchAgent: {
        multiple: true,
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListAgentBank({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.agentId,
                          text: item.name || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      },
      tableData: [],
      search: {},
      dateRange: {
        startDate: null,
        endDate: null
      },
      activationDateRange: {
        startDate: null,
        endDate: null
      },
      localeData: Config.localeData,
      pagination: {
        total: 0,
        page: 1,
        limit: 20
      }
    }
  },

  mounted () {
    this.fetchData()
    this.fetchĐataPartner()
  },

  methods: {
    async fetchĐataPartner () {
      try {
        const data = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.partnerCodeMap = data.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    onChangePage (page) {
      this.pagination.page = page
      this.fetchData()
    },
    resetFilters () {
      this.search = {}
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.activationDateRange = {
        startDate: null,
        endDate: null
      }
      this.pagination.page = 1
      this.fetchData()
    },

    transformDate () {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.search.fromImportDate = moment(this.dateRange.startDate)
          .startOf('day')
          .valueOf()
        this.search.toImportDate = moment(this.dateRange.endDate)
          .endOf('day')
          .valueOf()
      } else {
        delete this.search.fromImportDate
        delete this.search.toImportDate
      }
    },

    transformActivationDate () {
      if (
        this.activationDateRange.startDate &&
        this.activationDateRange.endDate
      ) {
        this.search.fromActiveDate = moment(
          this.activationDateRange.startDate
        )
          .startOf('day')
          .valueOf()
        this.search.toActiveDate = moment(this.activationDateRange.endDate)
          .endOf('day')
          .valueOf()
      } else {
        delete this.search.fromActiveDate
        delete this.search.toActiveDate
      }
    },

    async submitForm (event) {
      event.preventDefault()
      this.pagination.page = 1
      await this.fetchData()
    },
    filterObject (obj) {
      const result = {}

      let hasInvalidValue = false

      for (const [key, value] of Object.entries(obj)) {
        if (value === null || value === '0') {
          hasInvalidValue = true
          continue
        }
        result[key] = value
      }

      return hasInvalidValue ? result : obj
    },
    async fetchData () {
      try {
        this.loading = true
        const payload = this.filterObject(this.search)
        const res = await ReportService.getListDeviceReportBank({
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })
        this.$emit('params', {
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })

        if (res.code === 1000) {
          this.tableData = res.data || []
          this.pagination.total = res.totalPage.total ?? 0
        } else {
          this.showErr(res.message)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.showErr(error.message)
      } finally {
        this.loading = false
      }
    },
    showErr (message) {
      this.notiModal = true
      this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      this.msgNoti = message
    }
  }
}
</script>

<style scoped>
:deep(.box-search) {
  padding: 0 !important;
}

:deep(.card-body) {
  padding: 10px 0 !important;
}

:deep(.table tr.table-success) {
  background-color: #28a745 !important;
}

:deep(.table-success td) {
  color: white !important;
  font-weight: bold;
}
</style>
